import { AutoAwesome } from "@mui/icons-material"
import { useAnalytics } from "connected-components/analytics"
import { useCallback } from "react"
import { AI_TEAMMATE_EVENTS } from "../../analytics/events"
import SuggestedPrompts from "./suggested-prompts"
import "./style.scss"

const PROMPTING_GUIDE_URL = "https://support.ompnt.com/en/articles/11682079-chat-with-your-ai-teammate#h_a8c8c0d9ff"

export default function AiTeammateNoMessage() {
  const analytics = useAnalytics()

  const handlePromptingGuideClick = useCallback(() => {
    analytics.track(AI_TEAMMATE_EVENTS.PROMPTING_GUIDE_OPENED)
  }, [analytics])

  return (
    <div className="no-message">
      <div className="no-message-header">
        <AutoAwesome color="primary" />
        <div className="title">AI data teammate</div>
        <div className="subtitle">Ask how to use OP, or ask about your portfolio data — I&apos;ll answer with numbers and charts.</div>
      </div>
      <SuggestedPrompts surface="empty_state" />
      <div className="prompting-guide-link">
        <a
          href={PROMPTING_GUIDE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handlePromptingGuideClick}
        >
          Tips for asking good questions
        </a>
      </div>
    </div>
  )
}
